import { Button, Text } from "@chakra-ui/react";
import { AddBubbleIcon } from "../icons/AddBubbleIcon";
import { AddedBubbleIcon } from "../icons/AddedBubbleIcon";

export interface ComicInterestSelectorProps {
  title: string;
  isSelected?: boolean;
  fullWidth?: boolean;
  onClick: () => void;
}
export function ComicInterestSelector({
  title,
  isSelected = false,
  fullWidth = false,
  onClick,
}: ComicInterestSelectorProps) {
  return (
    <Button
      position="relative"
      isolation="isolate"
      mr="12px"
      width={fullWidth ? "100%" : "193px"}
      height="42px"
      gap="16px"
      background="transparent.black.40"
      borderRadius="200px"
      border="none"
      padding="8px"
      paddingLeft="24px"
      userSelect="none"
      onClick={onClick}
      justifyContent="space-between"
      alignItems="center"
      _before={{
        content: '""',
        position: "absolute",
        inset: 0,
        zIndex: -1,
        borderRadius: "inherit",
        padding: isSelected ? "2px" : "1px",
        background: isSelected
          ? "linear-gradient(45deg, #FF5A2C 0%, #FF5A2C66 50%, #FF5A2C 100%)"
          : "linear-gradient(45deg, rgba(255, 255, 255, 0.3) 0%, rgba(255, 255, 255, 0.1) 50%, rgba(255, 255, 255, 0.3) 100%)",
        WebkitMask:
          "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
        WebkitMaskComposite: "xor",
        maskComposite: "exclude",
        pointerEvents: "none",
        transition: "padding 0.2s ease-in-out, background 0.2s ease-in-out",
      }}
    >
      <Text
        fontSize="16px"
        fontWeight="500"
        color="neutral.300"
        fontFamily="Bricolage Grotesque"
        lineHeight="24px"
        textOverflow="ellipsis"
        overflow="hidden"
      >
        {title}
      </Text>
      {isSelected ? (
        <AddedBubbleIcon boxSize="24px" color="blaze.blaze" />
      ) : (
        <AddBubbleIcon boxSize="24px" color="neutral.500" />
      )}
    </Button>
  );
}
